/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';

import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  let productMinitature = new ProductMinitature();
  let productSelect = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();
  try {
    Typekit.load({
      async: true
    });
  } catch (e) {}


  // Touchscreen drop-down navigation
  function stopEvent(e) {
    e.preventDefault()
    e.stopPropagation()
    // console.log(e)
  }
  function openSubNav(target){
    $(target).next('.sub-menu').css({
      'display': 'block',
      'top': '96px'
    })
  }
  function closeSubNav(target) {
    $(target).next('.sub-menu').css({
      'display': 'none',
      'top': '96px'
    })
  }
  function toggleSubNav(e) {
    if ($('#category-42 .sub-menu').is(':visible')) {
      closeSubNav(e.currentTarget)
      $(e.currentTarget).find('.add').show()
      $(e.currentTarget).find('.remove').hide()
    } else {
      openSubNav(e.currentTarget)
      $(e.currentTarget).find('.add').hide()
      $(e.currentTarget).find('.remove').show()

    }
  }
  $('#category-42 [data-depth="0"]').on('touchstart', function (e) {
    console.log(e.currentTarget)
    stopEvent(e)
    toggleSubNav(e)
  })
  // END Touchscreen drop-down navigation

  // Search Bar Toggle
  $('#search-bar_toggle').on('click', function (e) {
    e.preventDefault()
    if ($('#search-bar_wrapper').attr('data-state') === 'not-shown') {
      $('#search-bar_wrapper').attr('data-state', 'is-shown')
      $('[name="s"]').focus()
    } else {
      $('#search-bar_wrapper').attr('data-state', 'not-shown')
    }
  })
  // END Search Bar Toggle


  // Pop-ups
  $("[data-show-popup]").each(function()
  {
    var popup = $("[data-popup='"+$(this).data('show-popup')+"']");
    if(popup.length > 0)
    {
      popup.addClass('popup--hide');
      $(this).on('click.popup', function(evt)
      {
        popup.removeClass('popup--hide');
      });
    }
  });

  $("[data-hide-popup]").each(function()
  {
    var popup = $("[data-popup='"+$(this).data('hide-popup')+"']");
    if(popup.length > 0)
    {
      $(this).on('click.popup', function(evt)
      {
        popup.addClass('popup--hide');
      });
    }
  });



  // OnLoad, track
  $(window).load(function()
  {
    // Tracking ======

    var gtmConversion = {
      event: 'purchase',
      transactionId: null,
      transactionTotal: null,
      transactionProducts: [],
    };

    // Purchase tracking
    $("[data-purchase]").each(function()
    {
      var $this = $(this);
      var data = $this.data('purchase');

      gtmConversion.transactionTotal = data.value;

      if(typeof window.fbq != 'undefined')
      {
        window.fbq('track', 'Purchase', data);
      }
    });

    // Conversion tracking
    $("[data-conversion]").each(function()
    {
      var $this = $(this);
      var data = $this.data('conversion');

      if(gtmConversion.transactionId === null)
      {
        gtmConversion.transactionId = data.order_id;
      }
      gtmConversion.transactionProducts.push({
        name: data.product_name,
        sku: data.product_id,
        price: data.price,
        quantity: data.quantity,
      });

      if(typeof window.fbq != 'undefined')
      {
        window.fbq('trackCustom', 'Conversion', data);
      }
    });

    // Push to tag manager if we've built up an object
    if(window.dataLayer && gtmConversion.transactionId !== null)
    {
      dataLayer.push(gtmConversion);
    }

  });
});



// WEBPACK FOOTER //
// ./js/theme.js